export default function functionDirective() {
  return {
    template: require('./function.html'),
    controller: 'FunctionController',
    controllerAs: 'functionVM',
    scope: {
      customerId: '<',
      department: '=',
      process: '=',
      function: '=',
      deleteCallback: '&',
      isEdit: '<',
      dialogOrigin: '<',
      isIt: '=',
      tooltipAppendToSelector: '@',
      assetCount: '=?',
      vendorCount: '=?',
    },
    bindToController: true,
    replace: true,
  };
}
